import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useMembersStore = defineStore('membersStore', {
  state: () => ({
    endpoint: 'users-data',
    loadingVat: false,
    loadingPrice: false,
    ...defaultState
  }),
  actions: {
    ...defaultActions,
    async checkVat(vat_number) {
      this.loadingVat = true
      this.error = null
      const config = useRuntimeConfig()
      try {
        const response = await $fetch(`${config.public.strapiApi}/${this.endpoint}/check-vat`, {
          method: 'POST',
          body: { vat_number }
        })
        this.loadingVat = false
        return response
      } catch (err) {
        console.error(err)
      }
    },
    async checkPrice(sugar_id, year) {
      this.loadingPrice = true
      this.error = null
      const config = useRuntimeConfig()
      try {
        const response = await $fetch(`${config.public.strapiApi}/${this.endpoint}/check-price`, {
          method: 'POST',
          body: { data: { sugar_id, year } }
        })
        this.loadingPrice = false
        return response
      } catch (err) {
        console.error(err)
      }
    }
  }
})
